import type { I18nFn } from '#/i18n/types/I18nFn';

export function CORP_ROLES(i18n: I18nFn) {
  return [
    {
      label: i18n('Sustainability'),
      value: 'SUSTAINABILITY',
    },
    {
      label: i18n('Diversity & Inclusion'),
      value: 'DIVERSITY_INCLUSION',
    },
    {
      label: i18n('Corporate Engagement / Citizenship / Social Responsibility'),
      value: 'SOCIAL_RESPONSIBILITY',
    },
    {
      label: i18n('Philanthropy'),
      value: 'PHILANTHROPY',
    },
    {
      label: i18n('Healthcare & Healing'),
      value: 'HEALTHCARE_AND_HEALING',
    },
  ];
}

export type CorpRole = ReturnType<typeof CORP_ROLES>[number]['value'];
